let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7D9sE")).then(() => parcelRequire('jLvfS'));